<template>
  <div class="biblioteca-icon-wrapper">
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="biblioteca-icon"
    >
      <path
        d="M2.71111 20.375C2.71111 20.8693 3.09598 21.2756 3.58911 21.3244L3.68889 21.3295H4.66667C5.20668 21.3295 5.64444 20.9022 5.64444 20.375V4.625C5.64444 4.09782 5.20668 3.67045 4.66667 3.67045V2C6.1517 2 7.35556 3.17525 7.35556 4.625V5.15028C7.7223 4.96722 8.1376 4.86364 8.57778 4.86364V6.53409C8.03777 6.53409 7.6 6.96146 7.6 7.48864V20.375C7.6 20.9022 8.03777 21.3295 8.57778 21.3295H9.55556C10.0956 21.3295 10.5333 20.9022 10.5333 20.375V7.48864C10.5333 6.96146 10.0956 6.53409 9.55556 6.53409V4.86364C10.0749 4.86364 10.5596 5.00764 10.9707 5.25655C10.8641 4.01493 11.6777 2.83864 12.9539 2.50477L13.8983 2.25775L14.0329 2.22605C15.3791 1.94431 16.7293 2.70559 17.1524 3.9846L17.1916 4.11417L20.1822 15.0089C20.3523 15.6287 20.2797 16.256 20.0223 16.7955H20.3111V18.4659H13.4667V16.7955H14.1007C14.0797 16.7363 14.0598 16.676 14.0429 16.6146L12.2444 10.0614V17.0821C12.6112 16.899 13.0265 16.7955 13.4667 16.7955V18.4659C12.9267 18.4659 12.4889 18.8933 12.4889 19.4205V20.375C12.4889 20.9022 12.9267 21.3295 13.4667 21.3295H20.3111C20.8511 21.3295 21.2889 20.9022 21.2889 20.375V19.4205C21.2889 18.8933 20.8511 18.4659 20.3111 18.4659V16.7955C21.7961 16.7955 23 17.9707 23 19.4205V20.375C23 21.8247 21.7961 23 20.3111 23H13.4667C12.6958 23 12.0014 22.6828 11.5111 22.1755C11.0208 22.6828 10.3264 23 9.55556 23H8.57778C7.80696 23 7.1125 22.6828 6.62222 22.1755C6.13195 22.6828 5.43749 23 4.66667 23H3.68889C2.20386 23 1 21.8247 1 20.375V4.625C1 3.17525 2.20386 2 3.68889 2V3.67045C3.14888 3.67045 2.71111 4.09782 2.71111 4.625V20.375ZM15.5387 4.54623C15.3989 4.03711 14.8629 3.73491 14.3413 3.87134L13.397 4.11836C12.8754 4.25479 12.566 4.77814 12.7056 5.28731L15.6958 16.1826C15.8356 16.6917 16.3717 16.9938 16.8932 16.8574L17.838 16.6104C18.3269 16.4825 18.6295 16.0145 18.5503 15.537L18.5293 15.4415L15.5387 4.54623ZM9.55556 4.86364V6.53409H8.57778V4.86364H9.55556ZM4.66667 2V3.67045H3.68889V2H4.66667Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "BibliotecaIcon",
};
</script>

<style scoped>
.biblioteca-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.biblioteca-icon {
  width: 1.25rem;
  height: 1.25rem;
}
</style>
